/**
 * Enables mocking for API requests if the environment mode is set to "mock".
 * This function dynamically imports and starts the Mock Service Worker (MSW)
 * to intercept and handle API requests for testing purposes.
 * When the reservations MFE is running locally, its mock handlers are also registered.
 *
 * @returns A Promise that resolves to the ServiceWorkerRegistration object if mocking is enabled,
 *          or undefined if mocking is not enabled.
 */
export async function enableMocking(): Promise<
  ServiceWorkerRegistration | undefined
> {
  if (import.meta.env.MODE !== 'mock') {
    return;
  }

  const { createWorker } = await import('../mocks/setupWorker');
  const worker = await createWorker();

  return worker.start({ onUnhandledRequest: 'bypass' });
}
